import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "emisphere_cookies_ok";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "tween", duration: 0.3 }}
          className="fixed bottom-4 left-4 right-4 z-[80] mx-auto max-w-xl sm:left-auto"
          data-testid="cookie-banner"
        >
          <div className="card-tactical glow-orange flex items-center gap-2 p-2 sm:gap-4 sm:p-4">
            <Cookie className="hidden h-8 w-8 shrink-0 text-orange-500 sm:block" />
            <p className="min-w-0 flex-1 text-[11px] leading-snug text-slate-300 sm:text-xs sm:leading-relaxed">
              <span className="sm:hidden">Cookies essentiels uniquement.</span>
              <span className="hidden sm:inline">Ce site utilise uniquement des cookies essentiels (panier, connexion). Aucun pistage publicitaire.</span>{" "}
              <Link to="/mentions-legales" className="font-bold text-orange-400 hover:underline">En savoir plus</Link>
            </p>
            <div className="flex shrink-0 gap-2">
              <button onClick={accept} data-testid="cookie-accept"
                className="h-11 whitespace-nowrap rounded-lg bg-orange-500 px-3 text-xs font-bold uppercase tracking-wider text-[#060B18] transition-all hover:bg-orange-400 sm:px-4">
                J'ai compris
              </button>
              <button onClick={accept} aria-label="Fermer" data-testid="cookie-close"
                className="hidden h-11 w-11 items-center justify-center rounded-lg border border-slate-600 text-slate-400 transition-colors hover:text-white sm:flex">
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
